<template>
  <div class="questionnaire-paper">
    <page-progress />
    <div class="questionnaire-wrapper">
      <div class="questionnaire-section">
        <div class="section-title">{{questionnaireData[0].questionsType}}</div>
        <div class="question-edit-list">
          <div class="question-item">
            <div class="type">初潮年龄 (岁)</div>
            <div class="content">
              <input type="number" v-model="menarche" placeholder="请输入">
            </div>
          </div>
          <div class="question-item">
            <div class="type">月经周期 (天)</div>
            <div class="content">
              <input type="number" v-model="cycle" placeholder="请输入">
            </div>
          </div>
          <div class="question-item">
            <div class="type">行经期天数 (天)</div>
            <div class="content">
              <input type="number" v-model="days" placeholder="请输入">
            </div>
          </div>
          <div class="question-item" @click="showLastMenstruationPicker">
            <div class="type">末次月经时间</div>
            <div class="content">
              <div class="question-selector">
                <span class="placeholder" v-if="!lastMenstruation">请选择</span>
                <span class="value" v-else>{{lastMenstruation | parseDateToDay}}</span>
                <icon icon-class="arrow" />
              </div>
            </div>
          </div>
          <div class="question-item" @click="showAmenorrheaPicker">
            <div class="type">是否闭经</div>
            <div class="content">
              <div class="question-selector">
                <span class="placeholder" v-if="!amenorrhea">请选择</span>
                <span class="value" v-else>{{amenorrhea}}</span>
                <icon icon-class="arrow" />
              </div>
            </div>
          </div>
          <div class="question-item" v-if="amenorrhea == '是'">
            <div class="type">闭经年龄 (岁)</div>
            <div class="content">
              <input type="number" v-model="amenorrheaAge" placeholder="请输入">
            </div>
          </div>
        </div>
      </div>
      <div class="questionnaire-section" v-for="section in questionnaireData">
        <div class="section-list">
          <div class="section-item" v-for="(item, index) in section.questionList">
            <div class="question">{{index + 1}}. {{item.question}}</div>
            <div class="anwser-content">
              <!-- 单选题 -->
              <div class="radio-group" v-if="item.questionType == 'radio'">
                <div class="radio-item" :class="{'checked': item.picked[0] == anwser}" @click="radioCheck(item, anwser)" v-for="anwser in item.options">
                  <span class="radio-icon"></span>{{anwser}}
                </div>
              </div>
              <!-- 多选题 -->
              <div class="multiple-group" v-if="item.questionType == 'mulitple'">
                <div class="multiple-item" :class="{'checked': item.picked.indexOf(anwser) != -1}" @click="multipleCheck(item, anwser)" v-for="anwser in item.options">
                  <span class="multiple-icon"><icon icon-class="anwser-checked"></icon></span>{{anwser}}
                </div>
              </div>
              <!-- 填写题 -->
              <div class="questionnaire-text" v-if="item.questionType == 'text'">
                <textarea class="anwser-text" maxlength="100" v-model="item.text" v-ios-bug-fixed :placeholder="item.placeholder"></textarea>
                <span class="text-limit">{{item.text.length}}/100</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="next-wrapper">
      <button class="next-button" @click="questionnaireConfirm = true">发送给医生</button>
    </div>
    <x-dialog v-if="questionnaireConfirm" title="是否确认发给医生" @close="questionnaireConfirm = false">
      <div class="content-wrapper">
        <div class="content-text">
          <p>问诊单发送给医生后将无法修改，<br>请仔细检查后再发送哦！</p>
        </div>
        <div class="confirm-control">
          <button class="cancel" @click="questionnaireConfirm = false">取消</button>
          <button class="confirm" @click="sendQuestionnaire" :disabled="sending">确认发送给医生</button>
        </div>
      </div>
    </x-dialog>
    <!-- 是否闭经 -->
    <van-popup v-model="AmenorrheaPickerShow" position="bottom">
      <van-picker
        show-toolbar
        :columns="amenorrheaData"
        value-key="label"
        @cancel="AmenorrheaPickerShow = false"
        @confirm="confirmAmenorrhea"
      />
    </van-popup>
    <!-- 末次月经时间 -->
    <van-popup v-model="LastMenstruationPickerShow" position="bottom">
      <van-datetime-picker
        show-toolbar
        type="date"
        v-model="lastMenstruation"
        :formatter="formatter"
        :max-date="maxDate"
        :min-date="minDate"
        @cancel="LastMenstruationPickerShow = false"
        @confirm="confirmMenstruation"
      />
    </van-popup>
  </div>
</template>

<style lang="less" scoped>
  .questionnaire-paper{
    background: #F7F7F7;
    .questionnaire-wrapper{
      padding-bottom: 1px;
      background: #FFF;
    }
    .questionnaire-section{
      border-bottom: 12px solid #F7F7F7;
      padding: 0 10px;
      background: #FFF;
      border-radius: 6px 6px 0 0;
      &:last-child{
        border-bottom: 0;
      }
      .section-title{
        height: 48px;
        border-bottom: 1px solid #EEE;
        display: flex;
        align-items: center;
        font-size: 16px;
        line-height: 16px;
        color: @xile;
        font-weight: bold;
      }
      .question-edit-list{
        padding: 32px 0;
        .question-item{
          margin-bottom: 40px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 15px;
          &:last-child{
            margin-bottom: 0;
          }
          .type{
            color: #666;
            flex-shrink: 0;
            font-weight: bold;
          }
          .content{
            display: flex;
            justify-content: flex-end;
            align-items: center;
            input{
              text-align: right;
              width: 50%;
              color: @black;
              padding-right: 7px;
            }
            .question-selector{
              display: flex;
              justify-content: flex-end;
              align-items: center;
              font-size: 15px;
              .placeholder{
                color: #999;
              }
              .value{
                color: @black;
              }
              svg{
                font-size: 15px;
                color: #CCC;
                margin-left: 8px;
              }
            }
          }
        }
      }
      .section-list{
        padding-top: 32px;
        .section-item{
          padding: 0 6px;
          margin-bottom: 36px;
          .question{
            font-size: 16px;
            line-height: 16px;
            font-weight: bold;
            color: @black;
          }
          .anwser-content{
            margin-top: 16px;
            .radio-group{
              display: flex;
              flex-wrap: wrap;
              align-items: flex-start;
              justify-content: flex-start;
              .radio-item{
                height: 22px;
                margin-right: 32px;
                margin-bottom: 15px;
                font-size: 14px;
                line-height: 14px;
                color: @black;
                font-weight: normal;
                display: flex;
                justify-content: flex-start;
                align-items: center;
                cursor: pointer;
                &.checked{
                  color: @xile;
                  font-weight: bold;
                  .radio-icon{
                    border-color: @xile;
                    &:after{
                      content: '';
                      position: absolute;
                      top: 50%;
                      left: 50%;
                      transform: translate(-50%, -50%);
                      width: 8px;
                      height: 8px;
                      background: @xile;
                      border-radius: 50%;
                    }
                  }
                }
                .radio-icon{
                  position: relative;
                  width: 12px;
                  height: 12px;
                  border: 1px solid #999;
                  border-radius: 50%;
                  margin-right: 12px;
                }
              }
            }
            .multiple-group{
              display: flex;
              flex-wrap: wrap;
              align-items: flex-start;
              justify-content: flex-start;
              .multiple-item{
                height: 22px;
                margin-right: 32px;
                margin-bottom: 15px;
                font-size: 14px;
                line-height: 14px;
                color: @black;
                font-weight: normal;
                display: flex;
                justify-content: flex-start;
                align-items: center;
                cursor: pointer;
                &.checked{
                  color: @xile;
                  font-weight: bold;
                  .multiple-icon{
                    border-color: @xile;
                    svg{
                      opacity: 1;
                      position: absolute;
                      top: 50%;
                      left: 50%;
                      transform: translate(-50%, -50%);
                      width: 12px;
                      height: 12px;
                      border-radius: 50%;
                      font-weight: bold;
                    }
                  }
                }
                .multiple-icon{
                  position: relative;
                  width: 12px;
                  height: 12px;
                  border: 1px solid #999;
                  border-radius: 2px;
                  margin-right: 12px;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  svg{
                    opacity: 0;
                  }
                }
              }
            }
            .questionnaire-text{
              width: 100%;
              position: relative;
              .anwser-text{
                border: 1px solid #F7F7F7;
                background: #F7F7F7;
                resize: none;
                padding: 12px;
                font-size: 14px;
                line-height: 20px;
                color: #666;
                width: 100%;
                height: 96px;
                &::-webkit-input-placeholder{
                  color: #999;
                }
              }
              .text-limit{
                position: absolute;
                right: 10px;
                bottom: 10px;
                font-size: 12px;
                color: #999;
              }
            }
          }
        }
      }
    }
    .next-wrapper{
      padding: 24px 24px 12px;
      background: #F7F7F7;
      .next-button{
        @button-base();
        width: 100%;
        height: 40px;
      }
    }

    .content-wrapper{
      padding: 40px 0 32px;
      text-align: center;
      .content-text{
        font-size: 14px;
        line-height: 22px;
        font-weight: normal;
        color: @black;
      }
      .confirm-control{
        margin-top: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
        button{
          @button-base();
          height: 36px;
          font-size: 14px;
          width: 120px;
          font-weight: normal;
          &.cancel{
            background: #FFF;
            border: 1px solid #999;
            color: #999;
            margin-right: 15px;
          }
          &.confirm{
            width: 152px;
          }
        }
      }
    }
  }
</style>

<script type="text/javascript">
  import pageProgress from '@/components/Common/pageScrollProgress'
  import questionnaireData from '@/config/questionnaire'
  import xDialog from '@/components/Common/dialog'
  export default {
    data() {
      return {
        questionnaireId: this.$route.query.id,
        // 初潮
        menarche: '',
        // 周期
        cycle: '',
        // 天数
        days: '',
        // 末次
        lastMenstruation: '',
        LastMenstruationPickerShow: false,
        // 年月最大值
        maxDate: new Date(),
        minDate: new Date(1900, 1, 1),
        // 闭经
        AmenorrheaPickerShow: false,
        amenorrhea: '',
        amenorrheaData: ['是', '否'],
        amenorrheaAge: '',
        questionnaireData: JSON.parse(JSON.stringify(questionnaireData.femaleWesten)),
        sending: false,
        questionnaireConfirm: false,
      }
    },
    components: {
      pageProgress,
      xDialog
    },
    created() {
      this.$root.post('/getAnswerDetail', {
        id: this.questionnaireId,
        type: 3
      }).then(data => {
        // 数据回显
        for(let item in data.third) {
          this[item] = data.third[item];
        }
        if(data.third.questions && data.third.questions.length > 0) {
          this.questionnaireData.forEach(section => {
            data.third.questions.forEach(dataSection => {
              if(dataSection.questionsType == section.questionsType) {
                section.questionList.forEach(item => {
                  dataSection.questionList.forEach(dataItem => {
                    if(dataItem.question == item.question) {
                      if(dataItem.questionType == 'text') {
                        item.text = dataItem.text;
                      }else {
                        item.picked = dataItem.picked;
                      }
                    }
                  })
                })
              }
            })
          })
        }
      })
    },
    methods: {
      // 单选
      radioCheck(item, anwser) {
        item.picked = [];
        item.picked.push(anwser);
      },
      // 时间选择器显示格式
      formatter(type, value) {
        if (type === 'year') {
          return `${value}年`;
        } else if (type === 'month') {
          return `${value}月`
        } else if(type === 'day') {
          return `${value}日`
        }
        return value;
      },
      showLastMenstruationPicker() {
        if(!this.lastMenstruation) {
          this.lastMenstruation = new Date();
        }
        this.LastMenstruationPickerShow = true;
      },
      showAmenorrheaPicker() {
        this.AmenorrheaPickerShow = true;
      },
      confirmMenstruation(value) {
        this.lastMenstruation = value;
        this.LastMenstruationPickerShow = false;
      },
      confirmAmenorrhea(value) {
        this.amenorrhea = value;
        this.AmenorrheaPickerShow = false;
      },
      sendQuestionnaire() {
        this.sending = true;
        let anwserData = [];
        this.questionnaireData.forEach(section => {
          // 获取每个大类下的已选问题
          let sectionData = [];
          section.questionList.forEach(question => {
            if((question.questionType == 'radio' || question.questionType == 'mulitple') && question.picked.length > 0) {
              sectionData.push({
                questionType: question.questionType,
                question: question.question,
                picked: question.picked
              })
            }
          })
          if(sectionData.length > 0) {
            anwserData.push({
              questionsType: section.questionsType,
              questionList: sectionData
            })
          }
        })
        let postData = {
          menarche: this.menarche,
          cycle: this.cycle,
          days: this.days,
          lastMenstruation: this.lastMenstruation,
          amenorrhea: this.amenorrhea,
          amenorrheaAge: this.amenorrheaAge,
          questions: anwserData.length > 0 ? anwserData : ''
        }
        console.log(postData);
        this.$root.post('/addPatientAnswer', {
          id: this.questionnaireId,
          status: 2,
          third: postData
        }).then(data => {
          this.sending = false;
          if(data.status == 1) {
            let _this = this;
            // 发送自定义的问诊单卡片
            let conversationType = RongIMLib.ConversationType.PRIVATE;
            // 获取targetId
            let targetId = data.info.doc_id.toString();
            let msg = new RongIMClient.RegisterMessage.AnswerMessage({
              username: data.info.username,
              sym_change: data.info.sym_change,
              create_time: data.info.create_time,
              birthday: data.info.birthday,
              gender: data.info.gender,
              id: data.info.id,
            })
            RongIMClient.getInstance().sendMessage(conversationType, targetId, msg, {
              onSuccess: function (message) {
                _this.$notify({
                  background: '#00848A',
                  message: '成功发送给医生'
                });
                _this.questionnaireConfirm = false;
                _this.$router.push('/patient');
              },
              onError: function (errorCode) {
                console.log('发送自定义消息失败', errorCode);
              }
            })
          }else {
            this.$notify(data.msg);
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Patient/Questionnaire/westenQuestionnaireFemale.vue